import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from './actions';
import {createOverallFilterTier, createFilterTier, isOverallFilterTier} from './filter-tier-interface';
import InputRadio from 'components/atoms/inputs/input-radio';
import {rangeOfNumbers} from 'helpers/array-helper';

class FilterByTiers extends Component {
    onChange(value) {
        this.props.dispatch(Action.set('PlayerTiersFilter', value));
    }

    getTabView(params) {
        const {value, tierNumber = 0, title, isChecked} = params;
        return (
            <label className={`tabs-chk tier-tab tier-${tierNumber}`} key={tierNumber}>
                <InputRadio value={value} checked={isChecked} onChange={::this.onChange} />
                <span>{title}</span>
            </label>
        );
    }

    render() {
        const {tiersFilter, slate, simpleMode} = this.props;

        const tabs = [
            this.getTabView({
                value: createOverallFilterTier(),
                title: 'All',
                isChecked: isOverallFilterTier(tiersFilter),
            }),
        ];

        const numbers = rangeOfNumbers(1, slate.tiers_quantity);

        numbers.map((number) => {
            const filterTier = createFilterTier(number);
            tabs.push(
                this.getTabView({
                    value: filterTier,
                    title: number,
                    tierNumber: number,
                    isChecked: tiersFilter.isKeyEqual(filterTier.getKey()),
                }),
            );
        });

        if (simpleMode) {
            return <div className="tabs-chk-holder">{tabs}</div>;
        }

        return (
            <div className="tier-filter">
                <label>Select Tier</label>
                <div className="tabs-chk-holder rounded-mode">{tabs}</div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig, playersData} = state;
    const {tiersFilter, slates} = playersData;

    return {
        tiersFilter,
        slate: slates.getById(sportConfig.getSlateId()),
    };
}

export default connect(mapStatesToProps)(FilterByTiers);
